export enum LayoutType {
  FULL = 'FULL',
  DEFAULT = 'Default',
  HOME = 'Home',
  APPROVAL = 'Approval',
  BOARD_DETAIL = 'BoardDetail',
  BOARD_DETAIL_MODAL = 'BoardDetailModal',
  WORK_MODAL = 'WorkModal',
}
export const MaxMobileWidthMap: { [key in LayoutType]: number } = {
  [LayoutType.FULL]: 769,
  [LayoutType.DEFAULT]: 769,
  [LayoutType.HOME]: 768,
  [LayoutType.APPROVAL]: 769,
  [LayoutType.BOARD_DETAIL]: 769,
  [LayoutType.BOARD_DETAIL_MODAL]: 769,
  [LayoutType.WORK_MODAL]: 769,
};
export const MaxDesktopWidthMap: { [key in LayoutType]: number | null } = {
  [LayoutType.FULL]: null,
  [LayoutType.DEFAULT]: 2050,
  // HOME 최대 2160px + 좌우 패딩 64px
  [LayoutType.HOME]: 2224,
  [LayoutType.APPROVAL]: 2250,
  [LayoutType.BOARD_DETAIL]: 1920,
  [LayoutType.BOARD_DETAIL_MODAL]: 1032,
  [LayoutType.WORK_MODAL]: 1408,
};
